import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByNodeId, useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { cardStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsLineCard";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LazyImage from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

interface IconsItem {
    fields: {
        icon: string;
        iconTitle: string;
        subTitle: string;
        itemNumber: number;
    }
}

interface InfoCardModel {
    fields: {
        iconTitle: string;
        textColor: string;
        primaryBackground: string;
        secondaryBackground: string;
    };
}

const enum fields {
    goalsCards = "goalsCards",
    title = "title",
    iconTitle = "iconTitle",
    description = "description",
    subTitle = "subTitle",
    textColor="textColor",
    primaryBackground="primaryBackground",
    secondaryBackground="secondaryBackground",
    infoCardTitle = "infoCardTitle",
    titleColor = "titleColor",
    icons = "icons",
    itemNumber = "itemNumber"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.goalsCards]: InfoCardModel[];
        infoCardTitle: string;
        titleColor: string;
        [fields.icons]: IconsItem[];
    };
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const {
        fields: { goalsCards, icons, infoCardTitle, titleColor },
    } = ownProps;
    const mappedInfoCards = [];
    for (const card of goalsCards) {
        mappedInfoCards.push(card.fields);
    }
    const iconList = [];
    for (const iconItem of icons) {
        iconList.push(iconItem.fields);
    }
    return {
        infoCardTitle, 
        titleColor,
        mappedInfoCards,
        icons:iconList
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface IInfoCardsStyles {
    container?: GridContainerProps;
    infoCard?: GridItemProps;
    customflyImgWrapper?: InjectableCss;
    customDescriptionText?: TypographyPresentationProps;
    infocardcontainer?: InjectableCss;
    infocardWraper?: InjectableCss;
    buttonStyle?: LinkPresentationProps;
    infoCardTitle?: InjectableCss;
    sectionWrapper?: InjectableCss;
    textWrapper?: InjectableCss;
    footerSectionWrapper?: InjectableCss;
    footerBtn?: ButtonPresentationProps;
    textIconWrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sectionTitleWrapper?: InjectableCss;
    infoCardWrapper?: InjectableCss;
    iconTitle?: InjectableCss;
    iconSubTitle?: InjectableCss;
    iconTitleGrid?: GridItemProps;
}

export const infoCardsStyles: IInfoCardsStyles = {
    infoCardTitle: {
        css: css`
            [data-test-selector="infoCardTitle"]{
                font-size: 1.7rem;
                font-weight: 500;
                margin: 20px 0px;
                margin-bottom: 20px;
                font-family: "Barlow-Regular";
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-left: 25px;
                            margin: 0px;
                        `,
                        css`
                            padding-left: 25px;
                            margin: 0px;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
            
        `,
    },
    infocardcontainer: {
        css: css`
            max-width: 1300px;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                        `,
                        css`
                            max-width: 100% !important;
                        `,
                        css`
                            max-width: 720px !important;
                        `,
                        css`
                            max-width: 960px !important;
                        `,
                        css`
                            max-width: 1300px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    container: {
        gap: 38,
        css: css`
            align-items: center;
            margin: 0 auto;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100% !important;
                            padding: 30px;
                        `,
                        css`
                            max-width: 100% !important;
                            padding: 30px;
                        `,
                        css`
                            max-width: 720px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 960px !important;
                            padding: 0 0px;
                        `,
                        css`
                            max-width: 1300px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    iconTitleGrid:{
        width: [12, 12, 3, 3, 3],
        css:css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          padding-bottom: 0px;   
                        `,
                        css`
                          padding-bottom: 0px; 
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `
    },
    infoCard: {
        width: [12, 12, 9, 9, 9],
        css: css`
            display: flex;
            flex-direction: column;
            min-height: 200px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                          padding-top: 0px;   
                        `,
                        css`
                          padding-top: 0px; 
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
    infocardWraper: {
        css: css`
            border-bottom: 5px solid ${getColor("primary.main")};
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            box-shadow: 1px 7px 11px 0px rgb(0 0 0 / 13%);
        `,
    },
    customflyImgWrapper: {
        css: css`
            box-sizing: border-box;
            width: 100%;
            height: 180px;
            overflow: hidden;
            div[class^="LazyImageStyle"] {
                width: 100%;
                height: auto;
            }
            img {
                height: 180px;
                width: 100%;
                object-fit: cover;
            }
        `,
    },
  
    customDescriptionText: {
        variant: "p",
        css: css`
            color: #33333a;
            font-size: 0.9rem;
            font-weight: 600;
            letter-spacing: 0;
            line-height: inherit;
            font-family: 'Barlow-Regular';
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        `,
    },
    buttonStyle: {
        css: css`
            span {
                background-color: transparent !important;
                color: ${getColor("primary.main")} !important;
                font-size: 14px;
                font-weight: bold;
                letter-spacing: 2px;
                line-height: normal;
                text-transform: uppercase;
                &:hover {
                    text-decoration: underline;
                }
            }
        `,
    },
    sectionWrapper:{
        css:css`
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            padding: 7px 15px;
        `
    },
    textWrapper:{
        css:css`
            flex-grow: 1;
            display: flex;
            flex-direction: column;
        `
    },
    footerSectionWrapper:{
        css:css`
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 4rem;
        `
    },
    footerBtn:{
        css:css`
            padding: 10px 15px;
            text-transform: uppercase;
            font-family: 'Barlow-Regular';
        `
    },
    textIconWrapper:{
        css:css`
            display: flex;
            gap: 20px;
            width: 100%;
        `
    },
    imageWrapper:{
        css:css`
            width: 40px;
            min-width: 40px;
            img{
            width: 40px;
            max-width: 38px;
            }
        `
    },
    iconTitle:{
        css:css`
            font-size: 1rem;
            font-weight: 600;
        `
    },
    iconSubTitle:{
        css:css`
        font-size: 0.9rem;
            
        
        `
    }
};

const styles = infoCardsStyles;

const DescriptionWrapper = styled.div`
    height: 100%;
`;

const InfoCards: React.FC<Props> = ({ id, infoCardTitle, 
        titleColor,
        mappedInfoCards,
        icons }) => {

    const cardItems = JSON.parse(JSON.stringify(mappedInfoCards))

    return (
        <>
            <StyledWrapper >
                <StyledWrapper {...styles.infocardcontainer}>
                    <GridContainer>
                        <GridItem width={12} {...styles.infoCardTitle}>
                            {infoCardTitle ? (
                                <Typography 
                                as="h2"
                                data-test-selector="infoCardTitle"
                                style={{color: titleColor ?  titleColor:"#000000" }}  
                                >{infoCardTitle}</Typography>
                            ) : null}
                        </GridItem>
                    </GridContainer>
                    {mappedInfoCards?.length > 0 ? (
                        <GridContainer {...styles.container}>
                            {mappedInfoCards?.map((card, index) => (
                                <GridItem width={12} style={{padding:"15px"}}>
                                    <GridContainer key={index}>
                                        <GridItem {...styles.iconTitleGrid}>
                                            <StyledWrapper 
                                                style={{ 
                                                    width: "100%",
                                                    display: "flex",
                                                    justifyContent: "left",
                                                    alignItems: "center",
                                                    height: "100%",
                                                    padding: "20px",
                                                    backgroundColor: card.primaryBackground
                                                    }}  
                                             >
                                                {card?.iconTitle && (
                                                    <Typography 
                                                    as="p"
                                                    style={{
                                                        fontSize: "1.6rem",
                                                        letterSpacing: 0,
                                                        margin: "0px",
                                                        fontWeight: 600,
                                                        textTransform: "uppercase",
                                                        fontFamily: "Barlow-Regular",
                                                        lineHeight: "33px",
                                                        color: card.textColor
                                                    }}  
                                                    >
                                                        {card.iconTitle}
                                                    </Typography>
                                                )}
                                            </StyledWrapper>
                                        </GridItem>
                                        <GridItem 
                                            {...styles.infoCard} 
                                        >
                                            <StyledWrapper
                                              style={{ 
                                                    height: "100%",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    gap: "18px",
                                                    padding: "20px",
                                                    width: "100%",
                                                    backgroundColor: card.secondaryBackground
                                                }}  
                                             >
                                                {icons.map((item, ind) => {
                                                    if(String(item.itemNumber) === String(index+1)){
                                                        return <StyledWrapper key={ind} {...styles.textIconWrapper}>
                                                            {item.icon && 
                                                                <StyledWrapper {...styles.imageWrapper}>
                                                                    <LazyImage src={item.icon} altText={item.iconTitle} />
                                                                </StyledWrapper>
                                                            }
                                                            <StyledWrapper {...styles.textWrapper}>
                                                                {item?.iconTitle && <Typography {...styles.iconTitle} >{item.iconTitle}</Typography>}
                                                                {item?.subTitle && <Typography {...styles.iconSubTitle} >{item.subTitle}</Typography>}
                                                            </StyledWrapper>
                                                        </StyledWrapper>
                                                    }
                                                }
                                                )}
                                            </StyledWrapper>
                                        </GridItem>
                                    </GridContainer>
                                </GridItem>
                            ))}
                        </GridContainer>
                    ) : null}
                    {/* <StyledWrapper {...styles.footerSectionWrapper}>
                        <Button {...styles.footerBtn}>
                            {siteMessage("Explore all spotlight stories")}
                        </Button>
                    </StyledWrapper> */}
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const membersList: WidgetModule = {
    component: connect(mapStateToProps)(InfoCards),
    definition: {
        group: "Basic",
        icon: "presentation-screen",
        fieldDefinitions: [
            {
                name: fields.goalsCards,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields) => {
                    return item.fields.iconTitle;
                },
                defaultValue: [],
                fieldType: "Translatable",

                sortOrder: 2,
                fieldDefinitions: [
                    {
                        name: fields.iconTitle,
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        sortOrder: 0,
                    },
                    {
                        name: fields.textColor,
                        displayName: "Text Color",
                        editorTemplate: "ColorPickerField",
                        defaultValue: "black",
                        sortOrder: 4,
                    },
                    {
                        name: fields.primaryBackground,
                        displayName: "Primary Background",
                        editorTemplate: "ColorPickerField",
                        defaultValue: "white",
                        sortOrder: 4,
                    },
                    {
                        name: fields.secondaryBackground,
                        displayName: "Secondary Background",
                        editorTemplate: "ColorPickerField",
                        defaultValue: "white",
                        sortOrder: 5
                    }
                    
                ],
            },
            {
                name: fields.infoCardTitle,
                displayName: "Title",
                editorTemplate: "TextField",
                defaultValue: "",
                sortOrder: 0,
                fieldType: "Translatable",
            },
            {
                fieldType: "Translatable",
                name: fields.titleColor,
                displayName: "Title color",
                editorTemplate: "ColorPickerField",
                defaultValue: "black",
                sortOrder: 1,
            },
            {
                name: fields.icons,
                displayName: "Icons",
                editorTemplate: "ListField",
                fieldType: "Translatable",
                getDisplay: (item: any) =>{
                    return "Item: "+ item?.fields?.itemNumber + " - " + item.fields.iconTitle  || "Icon";
                },
                fieldDefinitions: [
                    {
                        name: "icon",
                        displayName: "Icon",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: fields.iconTitle,
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: fields.subTitle,
                        displayName: "Sub Title",
                        editorTemplate: "MultilineTextField",
                        defaultValue: "",
                    },
                    {
                        name: fields.itemNumber,
                        displayName: "Item Number",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                ],
                defaultValue: [],
            },
            

        ],
    },
};

export default membersList;
